import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, adminOnly, roles }) => {
  const { userInfo } = useSelector((state) => state.auth);

  if (!userInfo) {
    return <Navigate to="/nklogin" replace />;
  }

  // roles 배열이 지정된 경우: 해당 역할만 접근 허용
  if (roles && !roles.includes(userInfo.role)) {
    return <Navigate to="/nkadmin/consultations" replace />;
  }

  // 기존 adminOnly 호환 유지
  if (adminOnly && userInfo.role !== 'admin') {
    return <Navigate to="/nkadmin/consultations" replace />;
  }

  return children;
};

export default ProtectedRoute;
